// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1LX10","wrapper-nopadding":"wrapper-nopadding__3Cd0E","loading":"loading__1SlK2","error":"error__27chj","table-loading":"table-loading__3zvan","empty-val":"empty-val__YlXzJ","panelheader-tools":"panelheader-tools__gG4U8","propsPanels":"propsPanels__1rcLV","new":"new__1XJbd","marginLm":"marginLm__2Bsxp","marginRm":"marginRm__2uDfq","fullWidth":"fullWidth__dgtkA","fullHeight":"fullHeight__3hqsL","noData":"noData__1l918","noperm":"noperm__3b7Mu","desc":"desc__2Ly0H","upgrade":"upgrade__2AfW3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageNoPerm/styles.scss
// module id = 2138
// module chunks = 1